export default "__VITE_ASSET__365fd3a1__"